// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zoom-on-hover[data-v-592b9618]{position:relative;overflow:hidden}.zoom-on-hover .normal[data-v-592b9618]{width:100%}.zoom-on-hover .zoom[data-v-592b9618]{position:absolute;opacity:0;transform-origin:top left}.zoom-on-hover.zoomed .zoom[data-v-592b9618]{opacity:1}.zoom-on-hover.zoomed .normal[data-v-592b9618]{opacity:0}", ""]);
// Exports
module.exports = exports;
